// Patient demographic + medical option lists (mirrors patient_portal's
// src/data/medicalOptions.js — same Xano `patient` table).
export const PREFIX_TH = ['น.ส.', 'นาง', 'นาย', 'ด.ช.', 'ด.ญ.']
export const PREFIX_EN = ['Mr.', 'Miss.', 'Mrs.', 'Ms.', 'Boy', 'Girl']

export const RELATIONSHIPS = ['บิดา', 'มารดา', 'คู่สมรส', 'แฟน', 'บุตร/ธิดา', 'พี่/น้อง', 'เพื่อน', 'อื่นๆ']

export const ALLERGY_OPTIONS = [
  'Amoxycillin',
  'Sulfa',
  'Ibuprofen',
  'Paracetamol',
  'Ponstan',
  'อาหารทะเล',
]

export const BLEEDING_MED_OPTIONS = [
  'Aspirin (81)',
  'Aspirin (325)',
  'Plavix (Clopidogrel)',
  'Warfarin/Orfarin',
  'Brilinta',
  'Rivaroxaban',
  'Dabigratan/Praxada',
]

export const DISEASE_OPTIONS = [
  'ความดันสูง',
  'ไขมันในเลือดสูง',
  'ลิ้นหัวใจรั่ว',
  'สูบบุหรี่',
  'เบาหวาน',
  'เส้นเลือดหัวใจตีบ',
  'ใส่ลิ้นหัวใจเทียม',
]
